<button class="btn border-0 px-0 h-100 w-100" (click)="toggleLanguage()">
  <span [ngClass]="{ 'text-end': translate.currentLang === 'ar', 'text-start': translate.currentLang !== 'ar' }" class="px-0 main-color">
    <i class="bi bi-translate"></i> {{ Language }}
  </span>
</button>